module.exports = __webpack_public_path__ + "static/media/download.c646b29a.svg";